const light = {
  dark: "18, 18, 18",
  white: "255, 255, 255",
  color: "17, 18, 20",
  input: "244, 247, 248",
  inputBorder: "216, 214, 222",
  background1: "255, 255, 255",
  background2: "244, 247, 248",
  background3: "235, 235, 236",
  text: "44, 62, 80",
  border: "235, 244, 231",
  gray1: "235, 235, 235",
  gray2: "244, 247, 248",
  gray3: "240, 243, 244",
  gray4: "247, 247, 247",
  gray5: "250, 251, 251",
};

const dark = {
  dark: " 255, 255, 255",
  white: "18, 18, 18",
  color: "17, 18, 20",
  input: "30,30,30",
  inputBorder: "171, 175, 179",
  background1: "50,50,50",
  background2: "30,30,30",
  background3: "30,30,30",
  text: "235, 235, 235",
  border: "65,65,65",
  gray1: "105,105,105",
  gray2: "80,80,80",
  gray3: "65,65,65",
  gray4: "50,50,50",
  gray5: "30,30,30",
};

export { light, dark };
